@import "../../../globals/bcp-2022/old-mixins/media";
@import "../../../globals/bcp-2022/old-mixins/bubble-triangle";

$background-color: #fff;
$border-color: #d9d9d9;
$border-size: 1px;
$bcp-flyout-z-index: 3;

bcp-add-to-cart {
  position: relative;
  display: block;

  .flyout-wrapper {
    display: none;
    position: absolute;
    width: auto;
    max-width: 100%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    border: $border-size solid $border-color;
    background-color: $background-color;
    z-index: $bcp-flyout-z-index + 2;

    &--active {
      display: block;
    }

    .flyout {
      position: relative;

      .flyout__content {
        z-index: $bcp-flyout-z-index;
        position: relative;
        background-color: $background-color;
      }
    }

    &.flyout--direction-down {
      bottom: auto;
      top: 100%;
      margin-top: rem(14px);
    }

    &.flyout--direction-up {
      top: auto;
      bottom: 100%;
      margin-bottom: 5px;
    }
  }

  button,
  .A-Button--regular {
    width: 100%;
    padding: 0 10px;

    svg {
      padding-right: 3px;
      vertical-align: middle;
    }

    span {
      vertical-align: middle;
    }

    &.flyout--active {
      &::before {
        @include bubble-triangle("top", #dfdfe0, 1px);
        position: absolute;
        top: 100%;
        left: 50%;
        z-index: $bcp-flyout-z-index + 1;
        background-color: $background-color;
        content: "";
      }
    }
  }

  @media only screen and (min-width: 768px) {
    .rb-core-modal--default .rb-core-modal__content {
      height: auto;
      padding: 1.5rem;
    }
  }

  @media only screen and (min-width: 1000px) {
    .modal--add-to-cart {
      min-width: 800px;
    }
  }

  .rb-core-modal--default .rb-core-modal__content {
    padding: 1.5rem;
  }

  .modal--add-to-cart {
    padding: 10px 20px;

    .A-Icon.A-Icon--close {
      float: right;
      margin-top: 10px;
    }

    &__buttons {
      display: flex;
      flex-direction: row;

      button {
        margin-right: 5px;
      }

      @media only screen and (max-width: 480px) {
        flex-direction: column;

        button {
          margin-right: 0;
          width: 100%;
          margin-top: 10px;

          &:first-child {
            order: 99;
          }
        }
      }
    }

    svg:hover {
      cursor: pointer;
    }
  }

  .flyout__cart-list {
    padding: 0;
    position: relative;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        list-style-type: none;
        color: #005691;
        font-size: 14px;
        overflow: hidden;
        text-align: left;
        margin: 0;

        &:hover {
          background-color: #efeff1;
          cursor: pointer;
        }

        button {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 10px;
          border: none;
          text-align: left;
          color: #005691;
          background-color: $background-color;

          &:hover {
            background-color: #efeff1;
            cursor: pointer;
          }
        }
      }
    }
  }
}
